export default {
    "Cancel": "Annuler",
    "Start": "Démarrer",
    "Date": "Date",
}